import { apiUpload, BtnType, ButtonGf, Container, FormGf, IcTextArea, navigationWeb, openError, useApi, useSelector } from 'gf-ui';
import { useEffect, useMemo, useRef } from 'react';
import { FaHome, FaPaperPlane } from 'react-icons/fa';
import { useDispatch } from 'react-redux';
// import { BtnBold, BtnBulletList, BtnClearFormatting, BtnItalic, BtnLink, BtnNumberedList, BtnRedo, BtnStrikeThrough, BtnUnderline, Editor, EditorProvider, Toolbar } from "react-simple-wysiwyg";
import { API_SERVICES } from '..';
// import BtnFontSize from '../../components/editor/BtnFontSize';
// import BtnTextColor from '../../components/editor/BtnTextColor';
import { useNavigate } from 'react-router-dom';
import BreadcrumbGF from '../../libQuestionario/components/BreadcrumbGF';
import { apiCefalee } from './api/apiCefalee';
import CEFHeader from './components/CEFHeader';


const CEFHome = () => {
    const navigate = useNavigate()
    const pageData = useSelector(state => state.page.data)
    const dispatch = useDispatch()
    const shouldInit = useRef(true)
    const _apiCefalee = useApi(apiCefalee, null, API_SERVICES.CEF.ROOT)
    const _apiUpload = useApi(apiUpload)

    // const [richiesta, setRichiesta] = useState("")
    // const [errore, setErrore] = useState(false)

    const breadcrumbItems = useMemo(() => {
        return [
            { label: API_SERVICES.CEF.NOME }
        ]
    }, [])

    // const isHtmlEmpty = (html) => {
    //     if (!html) return true;

    //     const div = document.createElement('div');
    //     div.innerHTML = html;

    //     const text = div.textContent || div.innerText || '';

    //     return text
    //         .replace(/\u00A0/g, ' ') // converte &nbsp;
    //         .trim()
    //         .length === 0;
    // };

    const onSubmit = (data) => {
        const allegati = data.ALLEGATI || []
        const richiesta = { ...data }
        delete richiesta.ALLEGATI

        _apiCefalee.fnSalva(res => {
            if (allegati.length === 0) {                
                navigate('/')
                return
            }

            console.log("res", res)

            const idRichiesta = res.kid
            if (!idRichiesta) {
                openError(dispatch, 'ID della richiesta non presente nella risposta di salvataggio', res)
                navigate('/')
                return
            }

            const formData = new FormData()
            allegati.forEach(allegato => formData.append('myfile', allegato, allegato.name))

            _apiUpload.fnUploadFileWeb(res => {
                const idsBlob = allegati
                    .map(allegato => res[allegato.name])
                    .filter(idBlob => idBlob !== undefined && idBlob !== null)

                if (idsBlob.length !== allegati.length) {
                    openError(dispatch, 'Errore durante l\'upload degli allegati', res)
                    navigate('/')
                    return
                }

                _apiCefalee.fnSalva(
                    () => navigate('/'),
                    { KID: idRichiesta, ID_BLOBS: idsBlob.join(',') },
                    () => navigate('/')
                )
            }, formData, () => navigate('/'))
        }, richiesta, () => navigate('/'))
    }

    useEffect(() => {
        if (shouldInit.current && _apiCefalee) {
            shouldInit.current = false
            navigationWeb(dispatch, [
                { label: "Home", icon: <FaHome />, route: "/", active: "/" }
            ])
        }
    }, [_apiCefalee, dispatch])

    return (
        <div>
            <CEFHeader label={pageData.SERVIZI_ABILITATI.find(s => s.CODICE === API_SERVICES.CEF.CODICE).DESCRIZIONE} />
            <BreadcrumbGF items={breadcrumbItems} />

            <Container className='mt-4 p-4 border bg-white'>
                <h5>Invia richiesta</h5>
                <div className='mb-2'>
                    Utilizza il campo sottostante per inviare una richiesta di supporto relativa alla gestione delle cefalee.<br />
                    Descrivi brevemente il caso e indica le informazioni che ritieni utili per consentire agli specialisti di fornire un riscontro adeguato.<br />
                    La richiesta sarà presa in carico e riceverà risposta entro 30 giorni dalla data di invio.
                </div>
                <FormGf id="frm-richiesta-cefalee" gf_submit={onSubmit}>
                    <IcTextArea id="RICHIESTA" label="Richiesta" rows={10} maxLength={4000} required />

                    {/* <IcFilePicker
                        id="ALLEGATI"
                        label="Allegati"
                        multiple={true}
                        maxFiles={5}
                        maxSize={10 * 1024 * 1024}
                        acceptedFiles={{ ...MIME_TYPE.PDF, ...MIME_TYPE.JPG, ...MIME_TYPE.PNG, ...MIME_TYPE.DOCX, ...MIME_TYPE.ZIP }}
                    /> */}

                    <div className='py-3 text-end'>
                        <ButtonGf type="submit" variant="success" gf_btn={BtnType.SAVE} gf_icona={<FaPaperPlane />} gf_label="INVIA RICHIESTA" />
                    </div>
                </FormGf>

                {/* <EditorProvider>
                        <Editor id="RICHIESTA" value={richiesta} onChange={onChangeRichiesta} style={{ height: `28vh` }}>
                            <Toolbar>
                                <BtnFontSize />
                                <BtnBold />
                                <BtnItalic />
                                <BtnUnderline />
                                <BtnBulletList />
                                <BtnNumberedList />
                                <BtnClearFormatting />
                                <BtnStrikeThrough />
                                <BtnLink />
                                <BtnRedo />
                                <BtnTextColor />
                            </Toolbar>
                        </Editor>
                    </EditorProvider> */}
            </Container>
        </div>
    )
}
export default CEFHome;